module.exports = __webpack_public_path__ + "static/img/p4_4.b0f8700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p4_4.png
// module id = UBHh
// module chunks = 0